import { render, staticRenderFns } from "./PostAnswerView.vue?vue&type=template&id=29cae82c&scoped=true"
import script from "./PostAnswerView.vue?vue&type=script&lang=js"
export * from "./PostAnswerView.vue?vue&type=script&lang=js"
import style0 from "./PostAnswerView.vue?vue&type=style&index=0&id=29cae82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cae82c",
  null
  
)

export default component.exports